import { render, staticRenderFns } from "./MobileApp-fr.vue?vue&type=template&id=78d9b37e&"
import script from "./MobileApp-fr.vue?vue&type=script&lang=js&"
export * from "./MobileApp-fr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports